import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { noHeaderCss } from "../../../sass/Main";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid/index";
import ConnectorVerticalCard from "./ConnectorVerticalCard";
import PaperHeader from "../PaperHeader";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Button } from "@material-ui/core";

import {
  wizardGetFeaturedConnectors,
  clearFeaturedConnectors,
  goToFinalWizardScreen,
  wizardChooseStep
} from "../../../redux/actions/gettingStartedWizardActions";
import Alert from "../Alert";

class ChooseConnectorsScreen extends React.Component {

  
  componentWillUnmount() {
    this.props.clearFeaturedConnectors();
  }

  shouldShowButton() {
    let showButton = false;
    if (this.props.connectors.hasOwnProperty("common")) {
      let filteredConnectors = this.props.connectors.common;  
      filteredConnectors = filteredConnectors.filter(item => item.area === this.props.area); 
      filteredConnectors.forEach(item => {
        if(this.checkIfConnected(item.connectorName) || item.connectorName === this.props.completedConnector){
          showButton = true;
        }
      })
    }
    return showButton; 
  }


  checkIfConnected(connectorName) {
    const connectors = this.props.connectors;
    let isConnected = false;
    if(connectors.hasOwnProperty("enabled")){
    connectors.enabled.forEach(item => {
       if(item.connectorName === connectorName && item.auth_exists){
         isConnected = true;
       }
    })}
    return isConnected;
  }

  renderConnectors() {
    let filteredConnectors = this.props.connectors.common;  
    filteredConnectors = filteredConnectors.filter(item => item.area === this.props.area);  
    const connectors = filteredConnectors.map(connector => (
      <Grid item xs={4} key={connector.connectorName}>
        <ConnectorVerticalCard
          imgSrc={connector.image}
          title={connector.connectorName}
          text={connector.longDesc}
          connector={connector}
          isConnected={connector.connectorName === this.props.completedConnector || this.checkIfConnected(connector.connectorName)}
        />
      </Grid>
    ));

    return (
      <Grid container direction="row" justify="center" alignItems="center" spacing={2}>
        {connectors}
      </Grid>
    );
  } 

  renderSpinner = () => {
    return <CircularProgress color="secondary" />;
  };

  renderErrorMessage = () => {
    return <Alert text="Could not retrieve featured connectors." kind="error" />;
  };

  renderMainContent = () => {
    if (!this.props.connectors.hasOwnProperty("common")) {
      return this.renderSpinner();
    }
      return this.renderConnectors();
  };

 
  render() {
    let title = this.props.title;
    return (
      <>
          <PaperHeader text={title} />
          {
            this.renderMainContent()
          }
          <br /><br /><br /><br />
          {
            this.shouldShowButton()&&
            <Button size="large" onClick={() => this.props.loadNextStep()} variant="contained" color="primary">Continue</Button>
          }
      </>
    );
  }
}

const ChooseConnectorsScreenStyled = withStyles(noHeaderCss)(ChooseConnectorsScreen);

const mapStateToProps = state => {
  return {
    featuredConnectors: state.gettingStartedWizard.featuredConnectors,
    featuredConnectorsStatus: state.gettingStartedWizard.featuredConnectorsStatus,
    createConnectionStatus: state.gettingStartedWizard.createConnectionStatus
  };
};

export default connect(
  mapStateToProps,
  {
    wizardGetFeaturedConnectors,
    clearFeaturedConnectors,
    goToFinalWizardScreen,
    wizardChooseStep
  }
)(ChooseConnectorsScreenStyled);
